"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavItem = _styledComponents["default"].div.withConfig({
  displayName: "NavigationDropdownItem__NavItem",
  componentId: "sc-1ar7f8l-0"
})(["&&&{font-size:1.125rem;padding:8px 1rem;color:", ";@media (min-width:768px){&&&{background-color:", ";}}&:hover{cursor:pointer;}}"], function (props) {
  return props.isActive ? "#041e42" : props.theme["white"];
}, function (props) {
  return props.isActive ? props.theme["mlb-secondary-blue"] : null;
});

var NavigationDropdownItem = function NavigationDropdownItem(_ref) {
  var isActive = _ref.isActive,
      onClick = _ref.onClick,
      name = _ref.name;
  return _react["default"].createElement("li", {
    className: "nav-item",
    id: "best-nav-dropdown-item"
  }, _react["default"].createElement(NavItem, {
    isActive: isActive,
    onClick: onClick
  }, name));
};

NavigationDropdownItem.propTypes = {
  isActive: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  name: _propTypes["default"].any.isRequired
};
NavigationDropdownItem.defaultProps = {
  isActive: false,
  onClick: function onClick() {}
};
var _default = NavigationDropdownItem;
exports["default"] = _default;